import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const HorariosAdmin = () => {
  const [horario, setHorario] = useState([]);
  const [editando, setEditando] = useState(false);
  const token = localStorage.getItem("token");

  const [tipoActivo, setTipoActivo] = useState("auto");
  const navigate = useNavigate();

  const obtenerFechaHoy = () => {
    const hoy = new Date();
    const yyyy = hoy.getFullYear();
    const mm = String(hoy.getMonth() + 1).padStart(2, "0");
    const dd = String(hoy.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const [fecha, setFecha] = useState(obtenerFechaHoy());

  const fetchCitas = async () => {
    if (!fecha) return;
    try {
      const response = await fetch("https://ricardodiaztuasesorfinanciero.com/api/horasdisponibles", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ fecha }),
      });
      const data = await response.json();
      if (data && data.resultado) {
        setHorario(data.resultado);
      } else {
        console.error("No se puede oiga[1h]");
      }
    } catch (error) {
      console.error("Error al obtener las citas", error);
    }
  };

  useEffect(() => {
    fetchCitas();
  }, [fecha, token]);

  const actualizarestadohora = async (fecha, hora, estado) => {
    try {
      const response = await fetch(
        "https://ricardodiaztuasesorfinanciero.com/api/actualizarestadohora",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ fecha, hora, estado }),
        }
      );
      const data = await response.json();
      if (data.message === "Cita editada correctamente") {
        fetchCitas();
      } else {
        console.error("No se puede oiga[2h]");
      }
    } catch (error) {
      console.error("Error al actualizar la hora", error);
    }
  };

  const cambiarHora = (index, valor) => {
    const nuevo = [...horario];
    nuevo[index].hora = valor;
    setHorario(nuevo);
  };

  const eliminarHora = (index) => {
    const nuevo = horario.filter((_, i) => i !== index);
    setHorario(nuevo);
  };

  const agregarHora = () => {
    setHorario([...horario, { hora: "" }]);
  };

  const guardarHorario = async () => {
    try {
      const soloHoras = horario
        .map((item) => ({ hora: item.hora }))
        .sort((a, b) => (a.hora > b.hora ? 1 : -1));
      const response = await fetch("https://ricardodiaztuasesorfinanciero.com/api/actualizarhorario", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ horario: soloHoras }),
      });
      const data = await response.json();
      console.log(data.response[0].cantidad_citas)
      console.log(data)
      if (data.ok) {
        Swal.fire({
              title: "Horarios guardados",
              icon: "success",
              draggable: true
            });
        if(data.response[0].cantidad_citas >= 1){
              Swal.fire({
              title: `Se encontraron ${data.response[0].cantidad_citas} citas sobre los horarios cambiados, considera ver los horarios antes de aliminar o cambiar horarios`,
              icon: "alert",
              draggable: true
            });
        }
        fetchCitas();
      } else {
        alert("Error al guardar horario");
      }
    } catch (error) {
      console.error("Error guardando horario:", error);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.cabecera}>
        <h2 style={styles.tituloCabecera}>📋 Panel de administración de horarios</h2>
        <div style={styles.botonera}>
          <button style={styles.botonRegresar} onClick={() => navigate('/')}>🏠 Menú Principal</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/CitasClientes')}>📆 Citas Pendientes</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/citasdespues')}>👥 Citas Finalizadas</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/adminseguros')}>📃 Formularios</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/horariosadmin')}>🕒 Horarios</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/adminblog')}>📰 Blog</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/aiuda')}>⚙️ Ayuda</button>
        </div>
      </div>

      <input
        type="date"
        value={fecha}
        min={obtenerFechaHoy()} 
        onChange={(e) => setFecha(e.target.value)}
        disabled={editando}
        style={styles.dateInput}
      />


      <button
        onClick={() => setEditando(!editando)}
        style={styles.toggleButton}
      >
        {editando ? "Cancelar edición" : "Editar Horas"}
      </button>

      {!editando ? (
        <ul style={styles.listadoHoras}>
          {horario.map((item, index) => (
            <li
              key={index}
              style={{ ...styles.horaItem, ...styles[`estado${item.estado}`] }}
            >
              <span style={{ fontWeight: "bold" }}>Hora:</span> {item.hora}
              <div style={styles.botonera}>
                <button
                  onClick={() => actualizarestadohora(fecha, item.hora, "0")}
                  style={styles.botonAccionVerde}
                >
                  Liberar
                </button>
                <button
                  onClick={() => actualizarestadohora(fecha, item.hora, "1")}
                  style={styles.botonAccionRojo}
                >
                  Bloquear
                </button>
                <button
                  onClick={() => actualizarestadohora(fecha, item.hora, "2")}
                  style={styles.botonAccionAmarillo}
                >
                  Ocupado
                </button>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <div>
          {horario.map((item, index) => (
            <div key={index} style={styles.edicionHora}>
              <input
                type="time"
                value={item.hora}
                onChange={(e) => cambiarHora(index, e.target.value)}
                style={styles.inputTime}
              />
              <button onClick={() => eliminarHora(index)} style={styles.btnEliminar}>
                Eliminar
              </button>
            </div>
          ))}
          <button onClick={agregarHora} style={styles.btnAgregar}>Agregar Hora</button>
          <br />
          <button onClick={guardarHorario} style={styles.btnGuardar}>Guardar Cambios</button>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: "40px",
    fontFamily: "Segoe UI, sans-serif",
    backgroundColor: "#eef2f7",
    minHeight: "100vh",
  },
  cabecera: {
    backgroundColor: '#102a43',
    color: 'white',
    padding: '20px',
    borderRadius: '12px',
    marginBottom: '30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  tituloCabecera: {
    fontSize: '24px',
    fontWeight: 'bold',
  },
  botonera: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    justifyContent: 'center',
    marginTop: '15px',
  },
  botonRegresar: {
    backgroundColor: '#334e68',
    border: 'none',
    color: 'white',
    padding: '10px 20px',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  tabs: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "10px",
    marginBottom: "30px",
  },
  tab: {
    padding: "10px 20px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  title: {
    fontSize: "26px",
    color: "#102a43",
    marginBottom: "20px",
    fontWeight: "bold",
  },
  dateInput: {
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    marginBottom: "15px",
  },
  toggleButton: {
    padding: "10px 20px",
    backgroundColor: "#334e68",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    marginLeft: "15px",
  },
  listadoHoras: {
    listStyle: "none",
    padding: 0,
    marginTop: "20px",
  },
  horaItem: {
    backgroundColor: "white",
    padding: "15px 20px",
    borderRadius: "12px",
    marginBottom: "15px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  botonAccionVerde: {
    backgroundColor: "#38a169",
    color: "white",
    border: "none",
    padding: "6px 12px",
    borderRadius: "6px",
    cursor: "pointer",
  },
  botonAccionRojo: {
    backgroundColor: "#e53e3e",
    color: "white",
    border: "none",
    padding: "6px 12px",
    borderRadius: "6px",
    cursor: "pointer",
  },
  botonAccionAmarillo: {
    backgroundColor: "#d69e2e",
    color: "white",
    border: "none",
    padding: "6px 12px",
    borderRadius: "6px",
    cursor: "pointer",
  },
  edicionHora: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
  },
  inputTime: {
    padding: "8px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    marginRight: "10px",
  },
  btnEliminar: {
    backgroundColor: "#e53e3e",
    color: "white",
    border: "none",
    padding: "6px 12px",
    borderRadius: "6px",
    cursor: "pointer",
  },
  btnAgregar: {
    backgroundColor: "#2b6cb0",
    color: "white",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    cursor: "pointer",
    marginTop: "10px",
  },
  btnGuardar: {
    backgroundColor: "#38a169",
    color: "white",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    cursor: "pointer",
    marginTop: "10px",
  },
  estado0: { color: "green" },
  estado1: { color: "red" },
  estado2: { color: "orange" },
};

export default HorariosAdmin;
